// extracted by mini-css-extract-plugin
module.exports = {"tooltip":"ob_WnFcEk","tooltip__white":"ob_5Aznxf","tooltipPopper":"ob_u7iyO3","arrow__white":"ob_0Dh520","arrow__black":"ob_Z8Aj3m","title":"ob_LQ62an"};